import type { SavedDancer } from "@recital-master/shared";

export function myDancerPlayLabel(
  dancers: Array<Pick<SavedDancer, "name">>
): string {
  return dancers.length === 1
    ? `Play ${dancers[0].name.split(" ")[0]}’s dances`
    : "Play my dancers";
}

export function savedDancersForRecital(
  dancers: SavedDancer[],
  recitalId: string
): SavedDancer[] {
  return dancers.filter((dancer) => dancer.recitalId === recitalId);
}
